import { ApprovalRules } from '../types';
import { unreachableFallback } from 'ui-product-approvals-common/utils/unreachableFallback';
export const getAvailableApprovalRules = ({
  approvalType
}) => {
  switch (approvalType) {
    case 'MARKETING_EMAIL':
    case 'LANDING_PAGE':
    case 'SITE_PAGE':
    case 'BLOG_POST':
    case 'DEAL':
    case 'KNOWLEDGE_ARTICLE':
    case 'QUOTE':
    case 'SOCIAL_BROADCAST':
      return [ApprovalRules.NON_SEQUENTIAL, ApprovalRules.ANY_CAN_APPROVE];
    case 'CONNECTED_APP':
      return [ApprovalRules.ANY_CAN_APPROVE];
    default:
      return unreachableFallback(approvalType, []);
  }
};